import {Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import {useMutateStripeSession} from "../../../api/payment/useMutateStripeSession";
import React, {useContext, useEffect} from "react";
import {PortfolioContext} from "../../../hooks/Context/PortfolioContext";
import Loading from "../../../components/UI/Loading/Loading";
import {Appearance, loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_TOKEN ?? '');

const PaymentLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [portfolio, setPortfolio] = useContext(PortfolioContext);
  const {session_id} = useParams();
  const {
    mutate: mutateStripeSession,
    isSuccess,
    isError,
    data
  } = useMutateStripeSession();

  useEffect(() => {
    let portfolio_id = portfolio?.id ? portfolio.id : localStorage.getItem('portfolio_id');
    if (session_id && portfolio_id) {
      if (!portfolio.clientSecret || session_id === 'session-id') {
        mutateStripeSession({
          portfolio_id: portfolio_id
        })
      }
    }
  }, [session_id])

  useEffect(() => {
    if (isSuccess && data) {
      setPortfolio({
        ...portfolio,
        clientSecret: data.clientSecret,
        banner_text: data.banner_text,
      })
      navigate(`/cpl-applicant/payment/${data.payment_intent_id}${location.search}`)
    }
  }, [isSuccess, data, navigate])

  useEffect(() => {
    if (isError) {
      navigate('/cpl-applicant');
    }
  }, [isError, navigate]);

  const appearance: Appearance = {
    theme: 'stripe',
  };
  const loader = 'auto';

  if (portfolio.clientSecret && session_id) {
    return <Elements
      options={{
        clientSecret: portfolio.clientSecret,
        appearance,
        loader
      }}
      stripe={stripePromise}
    >
      <Outlet/>
    </Elements>
  } else {
    return <Loading loading/>
  }
}

export default PaymentLayout;